import * as rb from './resource-bundle'

export const resourceBundleConfig = {
  "prod.royal-royal-en": new rb.ResourceBundleEnglishRoyalProd(),
  "proxy.prod-royal-en": new rb.ResourceBundleEnglishRoyalProd(),
  "prod.royal-royal-es": new rb.ResourceBundleSpanishRoyalProd(),
  "proxy.prod-royal-es": new rb.ResourceBundleSpanishRoyalProd(),
  "prod.royal-royal-pt": new rb.ResourceBundlePortugueseRoyalProd(),
  "proxy.prod-royal-pt": new rb.ResourceBundlePortugueseRoyalProd(),
  "prod.royal-royal-fr": new rb.ResourceBundleFrenchRoyalProd(),
  "proxy.prod-royal-fr": new rb.ResourceBundleFrenchRoyalProd(),
  "preprod.royal-royal-en": new rb.ResourceBundleEnglishRoyalProd(),
  "preprod.royal-royal-es": new rb.ResourceBundleSpanishRoyalProd(),
  "preprod.royal-royal-pt": new rb.ResourceBundlePortugueseRoyalProd(),
  "preprod.royal-royal-fr": new rb.ResourceBundleFrenchRoyalProd(),
  "prod.celebrity-celebrity-en": new rb.ResourceBundleEnglishCelebrityProd(),
  "preprod.celebrity-celebrity-en": new rb.ResourceBundleEnglishCelebrityProd(),
  "proxy.prod-celebrity-en": new rb.ResourceBundleEnglishCelebrityProd(),
  "prod.celebrity-celebrity-fr": new rb.ResourceBundleFrenchCelebrityProd(),
  "preprod.celebrity-celebrity-fr": new rb.ResourceBundleFrenchCelebrityProd(),
  "proxy.prod-celebrity-fr": new rb.ResourceBundleFrenchCelebrityProd(),
  "stage.royal-royal-en": new rb.ResourceBundleEnglishRoyalStage(),
  "proxy.stage-royal-en": new rb.ResourceBundleEnglishRoyalStage(),
  "stage.royal-royal-es": new rb.ResourceBundleSpanishRoyalStage(),
  "proxy.stage-royal-es": new rb.ResourceBundleSpanishRoyalStage(),
  "stage.royal-royal-pt": new rb.ResourceBundlePortugueseRoyalStage(),
  "proxy.stage-royal-pt": new rb.ResourceBundlePortugueseRoyalStage(),
  "stage.royal-royal-fr": new rb.ResourceBundleFrenchRoyalStage(),
  "proxy.stage-royal-fr": new rb.ResourceBundleFrenchRoyalStage(),
  "stage.celebrity-celebrity-en": new rb.ResourceBundleEnglishCelebrityStage(),
  "proxy.stage-celebrity-en": new rb.ResourceBundleEnglishCelebrityStage(),
  "stage.celebrity-celebrity-fr": new rb.ResourceBundleFrenchCelebrityStage(),
  "proxy.stage-celebrity-fr": new rb.ResourceBundleFrenchCelebrityStage(),
  "test.royal-royal-en": new rb.ResourceBundleEnglishRoyalTest(),
  "proxy.test-royal-en": new rb.ResourceBundleEnglishRoyalTest(),
  "test.royal-royal-es": new rb.ResourceBundleSpanishRoyalTest(),
  "proxy.test-royal-es": new rb.ResourceBundleSpanishRoyalTest(),
  "test.royal-royal-pt": new rb.ResourceBundlePortugueseRoyalTest(),
  "proxy.test-royal-pt": new rb.ResourceBundlePortugueseRoyalTest(),
  "test.royal-royal-fr": new rb.ResourceBundleFrenchRoyalTest(),
  "proxy.test-royal-fr": new rb.ResourceBundleFrenchRoyalTest(),
  "test.celebrity-celebrity-en": new rb.ResourceBundleEnglishCelebrityTest(),
  "proxy.test-celebrity-en": new rb.ResourceBundleEnglishCelebrityTest(),
  "test.celebrity-celebrity-fr": new rb.ResourceBundleFrenchCelebrityTest(),
  "proxy.test-celebrity-fr": new rb.ResourceBundleFrenchCelebrityTest()
}
